<template>
	<section class="view-onboarding-unlock" id="view-onboarding-unlock">
		<section class="graphic">
			<slot name="graphic:before"></slot>
			<!-- <img src="@/Asset/image/onboarding/onboarding-graphic-03.avif" alt="Onboarding Graphic" /> -->
			<video autoplay muted loop playsinline>
				<source src="@/Asset/video/onboarding-unlock.webm" type="video/webm" />
				<source src="@/Asset/video/onboarding-unlock.mp4" type="video/mp4" />
			</video>
			<slot name="graphic:after"></slot>
		</section>

		<section class="content">
			<h2 class="title">Learn &amp; Improve</h2>
			<p class="large description">
				Drills, guides, and tools to
				<br />
				level up your game
			</p>
		</section>

		<section class="actions">
			<ViewUiButtonContinue v-on:continue="$emit('continue')" />
		</section>
	</section>
</template>

<script lang="ts">
	import ChalkySticks from '@chalkysticks/sdk';
	import ViewBase from '@/Core/View.vue';
	import { Component } from 'vue-property-decorator';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Onboarding
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewOnboardingUnlock extends ViewBase {
		// Not implemented
	}
</script>

<style lang="scss">
	.view-onboarding-unlock {
		background-image: url('@/Asset/image/onboarding/onboarding-background-03.avif');
	}
</style>
